import { useDialogStore } from "@/shared/stores";
import { Button } from "@spz/ui/components/button";
import { useTranslation } from "react-i18next";
import { CompanyGroupForm } from "../forms/company-group-form";

export const useCreateOrUpdateCompanyGroupDialog = () => {
  const { openDialog, closeDialog } = useDialogStore();
  const { t } = useTranslation();

  return {
    open: ({ groupId }: { groupId?: string } = {}) => {
      openDialog({
        header: {
          title: t("company_groups_management_title"),
        },
        content: (
          <CompanyGroupForm
            className="max-h-[70vh] overflow-y-auto overscroll-y-auto overflow-x-hidden pink-scroll"
            groupId={groupId}
            onSuccess={closeDialog}
          />
        ),
        footer: {
          actions: (
            <Button type="submit" form="company-group-form">
              {t("validate")}
            </Button>
          ),
        },
      });
    },
  };
};
